import apiService from "./apiService";
import AppConstants from "../appConstants";

class LayoutService {
  saveLayout(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_LAYOUT, form, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  loadLayout(params) {
    return new Promise((resolve, reject) => {
      apiService.get(AppConstants.URL_LAYOUT, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  loadLayoutWDMA(params) {
    return new Promise((resolve, reject) => {
      apiService.get(AppConstants.URL_LAYOUT, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  saveLayoutWDMA(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_LAYOUT, form, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  loadLayoutHistWDMA(params) {
    return new Promise((resolve, reject) => {
      apiService.get(AppConstants.URL_LAYOUT_WDMA_HIST, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  findOneLayoutHistWDMA(id, params) {
    return new Promise((resolve, reject) => {
      apiService.get(`${AppConstants.URL_LAYOUT_WDMA_HIST}/${id}`, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  
}

export default new LayoutService();
